import angular from 'angular';
import '../../services/globals';
import '../../services/reception';
import '../../services/errors';
import '../../components/operator';
import '../../components/status';
import { get, isEmpty, toLower } from 'lodash';
import { localStorage } from '../../utils';

const module = angular.module('whyline.controllers.reception-path', [
  'whyline.services.globals',
  'whyline.services.reception',
  'whyline.services.errors',
  'whyline.components.operator',
  'whyline.components.status',
]);

const ReceptionPathController = ($scope, $state, $timeout, $translate, SchemaService, GlobalsService, ReceptionService, ErrorService) => {
  /*@ngInject*/

  $scope.currentPage = 1;

  $scope.title = '';

  ReceptionService.SetButtonStatus('back', true);
  ReceptionService.SetButtonStatus('forward', false);
  ReceptionService.SetButtonStatus('status-text', false);

  if (GlobalsService.CurrentPlace.placeId) {
    $scope.currentPlaceId = GlobalsService.CurrentPlace.placeId;
  } else {
    $scope.currentPlaceId = $state.params.placeId;
  }

  const identificationData = localStorage.get('identificationData');

  const firstName = get(identificationData, 'firstName', '') || '';
  const lastName = get(identificationData, 'lastName', '') || '';
  const companyName = get(identificationData, 'companyName', '') || '';

  if (companyName) {
    $scope.title = $translate.instant('services_hello_company', { companyName });
  } else if (firstName && lastName) {
    $scope.title = $translate.instant('services_hello_person', { firstName, lastName });
  } else {
    $scope.title = $translate.instant('services_hello');
  }

  const idNumber = get(identificationData, 'idNumber', '') || '';
  const idType = toLower(get(identificationData, 'idType', '')) || '';
  const gender = get(identificationData, 'gender', '') || '';

  if ($state.params.n == 0) {
    let queuePromise = null;

    if (!isEmpty(identificationData)) {
      queuePromise = SchemaService.GetQueues(idNumber, idType, !companyName ? gender : '');
    } else {
      queuePromise = SchemaService.GetAllPopulated();
    }

    queuePromise.then(items => {
      $timeout(() => {
        clearTree(items);
        $scope.items = items;
      });
    })
    .catch(ErrorService.handler);
  }

  // Get current item in the actual path
  if($state.params.n != 0) {
    $timeout(() => {
      const step = ReceptionService.GetCurrent();
      if(step && step.items) {
        $scope.items = step.items;
      }
    });
  }

  const clearTree = (services) => {
    for (let i = services.length -1; i >= 0; i--) {
      const service = services[i];
      if (service.type === 'sector' && isEmpty(service.tree)) {
        services.splice(i, 1);
      } else if (service.type === 'sector' && !isEmpty(service.tree)) {
        clearTree(service.tree);

        if (isEmpty(service.tree)) {
          services.splice(i, 1);
        }
      }
    }
  }
};

module.exports = module.controller('ReceptionPathController', ReceptionPathController);
